
import BannerTop from "@/components/home/bannerTop.vue";
import CommonTitle from "@/components/home/commonTitle.vue";
export default {
  name:"cloud",
  components: {
    CommonTitle,
    BannerTop,
    // Notice
  },
  data() {
    return {
      bannerUrl:require("@/static/images/coreTechnology/banner.png"),
      imageList: [
        {
          id: 1,
          src: require(`@/static/images/coreTechnology/cloud/cloud1${this.$i18n.locale == 'en' ? '' : ''}.png`),
          imgStyle:{
            width:"386px",
            height:"620px"
          }
        }
      ],
    }
  },
  computed: {
    contentList () {
      return this.$t('technology.cloud.contentList')
    },
  }
}
